import { useCallback, useEffect } from 'react';
import { selectVaultsList, addVaultsBalanceByAddress } from '../../store/vaults';
import IGUniPoolABI from '../../abis/arrakis-vaults.json';
import { ContractCallContext } from "ethereum-multicall";
import { useDispatch, useSelector } from "react-redux";
import { utils } from 'ethers';
import { fetchVaultsBalance } from '../../utils/fetchVaultsBalance';
import { allProviders } from '../../constants/providers';

// TODO: This component should update on block polling
export const VaultsBalanceLoader = ({ chainId, account }: { chainId: number; account?: string }) => {
  console.log('VaultsBalanceLoader', chainId, account);
  const dispatch = useDispatch();
  const whitelistedVaults = useSelector(selectVaultsList);
  const whitelistedVaultsByChainId = whitelistedVaults.filter((v) => v.chainId === chainId);

  const fetchBalance = useCallback(async () => {
    const start = Date.now()
    console.log(
      `fetchiing vaults balance for chain ${chainId} START at (${Date.now().toString()})}`
    )
    // fetch Balance
    const contractCallContext: Array<ContractCallContext> = whitelistedVaultsByChainId.map(vault => {
      if(chainId === 137 && vault.gauge) {
        return {
          reference: utils.getAddress(vault.address),
          contractAddress: utils.getAddress(vault.gauge.address),
          abi: IGUniPoolABI,
          calls: [{ reference: 'balanceCall', methodName: 'balanceOf', methodParameters: [account] }]
        }
      } else {
        return {
          reference: utils.getAddress(vault.address),
          contractAddress: utils.getAddress(vault.address),
          abi: IGUniPoolABI,
          calls: [{ reference: 'balanceCall', methodName: 'balanceOf', methodParameters: [account] }]
        }
      }
    })
    const balances = await fetchVaultsBalance(allProviders[chainId], contractCallContext);
    console.log(
      `fetching vaults balance COMPLETE at (${Date.now().toString()})}`
    )
    console.log(`Took ${((Date.now() - start) / 1000).toLocaleString('en-US')}}`)
    balances.forEach(balance => {
      dispatch(addVaultsBalanceByAddress({
        chainId,
        vaultAddress: utils.getAddress(balance.address),
        balance: balance.balance
      }))
    })
  }, [account, chainId, dispatch, whitelistedVaultsByChainId])

  useEffect(() => {
    if(account)
      fetchBalance();
  }, [account, fetchBalance]);
  return null;
}